import {AxiosError} from 'axios';
import {useQuery} from 'react-query';
import {toast} from 'react-toastify';
import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';

import {getLoanRequest} from './getLoanRequest';

interface ErrorResponse {
  code?: string;
  detail?: string;
}

interface UseGetLoanRequestProps extends IGetLoanRequestPayload {
  onError?: (error: AxiosError<ErrorResponse>) => void;
}

const useGetLoanRequest = ({
  loanRequestGuid,
  enabled,
  onError,
}: UseGetLoanRequestProps) => {
  const {data, isLoading, error} = useQuery({
    queryKey: ['loan-request', loanRequestGuid],

    queryFn: () => getLoanRequest(loanRequestGuid),

    enabled,

    onError: (error: AxiosError<ErrorResponse>) => {
      onError?.(error);

      if (error.response?.status === 400) {
        const errorCode = error.response.data?.code;

        toast.error(getPersianErrorCode(errorCode));

        return;
      }

      toast.error('خطایی رخ داده است');
    },
  });

  return {data, isLoading, error};
};

export default useGetLoanRequest;
